import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import ParticleBackground from "../components/common/ParticleBackground";

export default function Failure() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        background: `
          radial-gradient(circle at 50% 0%, rgba(255,110,0,0.15), transparent 40%),
          linear-gradient(180deg, #141414 0%, #2a1208 100%)
        `
      }}
    >
      <ParticleBackground />

      <Typography
        variant="h3"
        sx={{
          color: "#fff",
          mb: 2,
          textShadow: "0 0 20px rgba(255,0,0,0.7)"
        }}
      >
        ❌ Pago rechazado
      </Typography>

      <Typography sx={{ color: "#aaa", mb: 4 }}>
        Hubo un problema con el pago
      </Typography>

      <Button
        component={Link}
        to="/shop"
        variant="contained"
      >
        Intentar nuevamente
      </Button>
    </Box>
  );
}